import React, { useState, useContext, useEffect } from "react";
// impsort "bootstrap/dist/css/bootstrap.min.css";
import { StoreContext } from "../store";
import Image from "react-bootstrap/Image";
import ContactUsModal from "./atoms/molecules/ContactUsModal";
import { GetBirds } from "../actions";
import { Link } from "react-router-dom";
let Home = (props) => {
  const { dispatch } = useContext(StoreContext);

  const [showContactModal, setShowContactModal] = useState(false);

  const hideModalClick = () => {
    setShowContactModal(false);
  };

  const handleShowContact = () => {
    setShowContactModal(true);
  };

  const style = {
    color: "red",
  };

  const styleMO = {
    color: "yellow",
  };

  return (
    <div className="container">
      <div className="mission-statement">
        <p style={{fontFamily:'serif', fontWeight:'bolder', color:'black', fontSize:'30px'}}>
          Producing Top Quality And Performance Racing Pigeons To Compete At The Highest Level
        </p>
        <div
          style={{
            height: "100%",
            width: "100%",
            padding: "20px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            fontSize:"15px",
            color:'#ea5d63',
            fontWeight:'bold'
          }}
        >
          <div style={{ margin: "5px" }}>
            <Image
              src={require("../images/NewInbredKittleCimport.jpg")}
              alt="Kittle"
              style={{
                width: "250px",
                height: "200px",
              }}
            />
            <br></br>
            Kittle
          </div>

          <div style={{ margin: "5px" }}>
            <Image
              src={require("../images/Jazzmansdaucropped.jpg")}
              alt="Jazzman/Raven"
              style={{
                width: "250px",
                height: "200px",
              }}
            />
                        <br></br>
            Jazzman/Raven
          </div>
          <div style={{ margin: "5px" }}>
            <Image
              src={require("../images/DrapaKittelredo.png")}
              alt="Kittle"
              style={{
                width: "250px",
                height: "200px",
              }}
            />
            <br></br>
            Kittle
          </div>

          <div style={{ clear: "both" }}></div>
        </div>
        <p style={{fontFamily:'serif', fontSize:'25px', color:'black'}}>
        Housing all the hottest strains of pigeons from USA, Africa & Europe.   The bloodlines that are winning at One Loft Races, Futurities, Clubs,  and Combines!
        </p>
        <div
          style={{
            textAlign: "left",
            padding: "20px",
          }}
        >
          <h2 style={{ color: "red", fontStyle: "italic" }}>LATEST NEWS</h2>
          <div
            style={{
              textAlign: "left",
              border: ".5px solid red",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Courier",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  backgroundColor: "red",
                }}
              >
                Our 2020 Victoria Falls Highlights
              </span>
              <br />
              Race 2 65th vs 2949b. Race 3 127th & 241st vs 2839b.Hotspot 1
              240th vs 2667b. Hotspot 3 301st vs 2407b. Hotspot 4 123rd vs
              2253b. Hotspot 5 28th & 36th vs 968b.at 250mi.
              <br />
              <mark
                style={{
                  backgroundColor: "red",
                  fontSize: "26px",
                }}
              >
                Team Competition 7th place & 1st American Loft of the 107 Teams
                entered (5 bird teams)!!!
                <br />
                Final Race 36th with only 77 day birds, 268th & 400th with only
                521 total returns of 859b. 344mi.
              </mark>
            </p>
          </div>
        </div>
        
        <p style={{'color':'#003baf', 'fontSize':'30px', 'fontWeight':'bolder'}}>      
          {/* <a
            href="#"
            className="orderNowSpan"
            onClick={() => handleShowContact()}
            style={{ color: "red" }}
          >
            ORDER NOW!
          </a> */}
          We now house over 40 superb imports with top bloodlines and fantastic eye sign! We also house many super American born pigeons from our & other top lofts.
          To browse click <Link to={"./importbirds"}> <span style={{fontWeight:'bolder',color:'red'}}>Imports</span> </Link> and <Link to={"./usbirds"}> <span style={{fontWeight:'bolder',color:'red'}}>USA Birds</span></Link>.
          </p>


        <h3>
          All birds for sale, email us for quote or any question you have.
        </h3>
      </div>
      {showContactModal ? (
        <ContactUsModal
          show={showContactModal}
          closeModal={() => hideModalClick()}
        />
      ) : null}
      <br />
    </div>
  );
};

export default Home;
